import React, { Component } from "react";
import ErrorPage from "../ErrorPage/ErrorPage";


class Page500 extends Component {
  render() {
    const error = {
      code: 500,
      title: "Houston, we have a problem !",
      message: "The page you are looking for is temporarily unavailable."
    }
    return (
      <ErrorPage error={error}/>
    );
  }
}

export default Page500;



// WEBPACK FOOTER //
// ./src/views/Pages/Page500/Page500.js